import styled from 'styled-components';

export const ImageContainer = styled.img`
  &.hidden {
    display: none;
  }
`;
